import { render, staticRenderFns } from "./receber-parcela-lote.vue?vue&type=template&id=3368d42e&scoped=true"
import script from "./receber-parcela-lote.vue?vue&type=script&lang=js"
export * from "./receber-parcela-lote.vue?vue&type=script&lang=js"
import style0 from "./receber-parcela-lote.vue?vue&type=style&index=0&id=3368d42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3368d42e",
  null
  
)

export default component.exports